export enum WindowBreakpoints {
  XS = 375,
  SM = 768,
  MD = 1024,
  LG = 1440,
  XL = 1920
}
